<ion-button
  color="grey-500"
  (click)="setValue('down')"
  fill="outline"
  class="downButton"
>
  <ion-icon
    color="grey-500"
    slot="icon-only"
    name="chevron-down"
    aria-label="Decrease the number"
  ></ion-icon>
</ion-button>

<ion-input
  type="number"
  [(ngModel)]="number"
  [disabled]="disabled"
  [required]="required"
  [attr.aria-required]="required"
  [step]="stepping"
></ion-input>

<ion-button
  color="grey-500"
  (click)="setValue('up')"
  fill="outline"
  class="upButton"
>
  <ion-icon
    color="grey-500"
    slot="icon-only"
    name="chevron-up"
    aria-label="Increase the number"
  ></ion-icon>
</ion-button>
